import { useEffect, type RefObject } from 'react';

/**
 * 点击给定元素集合外部时触发回调（document 级 mousedown 捕获监听）。
 * 相比全屏透明遮罩方案，不依赖 z-index/层叠上下文，弹窗自身事件不会被拦截。
 * @param refs 目标元素集合（弹窗根节点 + 触发按钮等需视为“内部”的节点）
 * @param handler 点击外部时的回调
 * @param active 是否启用监听（弹窗关闭时传 false，避免多余监听）
 */
export function useClickOutside(
  refs: (RefObject<HTMLElement | null> | undefined)[],
  handler: () => void,
  active: boolean
): void {
  useEffect(() => {
    if (!active) return;

    const onPointerDown = (e: MouseEvent) => {
      const target = e.target as Node;
      const inside = refs.some((r) => r?.current?.contains(target));
      if (!inside) handler();
    };

    document.addEventListener('mousedown', onPointerDown, true);
    return () => document.removeEventListener('mousedown', onPointerDown, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, handler, ...refs]);
}
